// 状态管理器
class StateManager {
    constructor() {
        this.state = {
            currentPage: 'home',
            isRecognizing: false,
            videoStream: null,
            countdownInterval: null,
            progressInterval: null,
            capturedImage: null,
            analysisData: null
        };
        
        this.listeners = [];
    }

    // 获取状态
    getState() {
        return { ...this.state };
    }

    // 更新状态
    setState(newState) {
        const oldState = { ...this.state };
        this.state = { ...this.state, ...newState };
        this.notifyListeners(oldState, this.state);
    }

    // 添加状态监听器
    addListener(listener) {
        this.listeners.push(listener);
    }

    // 移除状态监听器
    removeListener(listener) {
        const index = this.listeners.indexOf(listener);
        if (index > -1) {
            this.listeners.splice(index, 1);
        }
    }

    // 通知监听器
    notifyListeners(oldState, newState) {
        this.listeners.forEach(listener => {
            listener(oldState, newState);
        });
    }

    // 重置拍摄状态
    resetCaptureState() {
        this.setState({
            isRecognizing: false,
            capturedImage: null
        });
    }

    // 清理定时器
    clearTimers() {
        if (this.state.countdownInterval) {
            clearInterval(this.state.countdownInterval);
            this.setState({ countdownInterval: null });
        }
        
        if (this.state.progressInterval) {
            clearInterval(this.state.progressInterval);
            this.setState({ progressInterval: null });
        }
    }

    // 停止摄像头
    stopCamera() {
        if (this.state.videoStream) {
            this.state.videoStream.getTracks().forEach(track => track.stop());
            this.setState({ videoStream: null });
        }
    }

    // 完全重置状态
    resetAll() {
        this.clearTimers();
        this.stopCamera();
        this.setState({
            currentPage: 'home',
            isRecognizing: false,
            capturedImage: null,
            analysisData: null
        });
    }
}

// 导出状态管理器实例
const stateManager = new StateManager();
export default stateManager; 